import React, { useMemo, useState } from 'react'
import classNames from 'classnames'

import { Show } from '@app/components/util'
import { DropdownMenuItem } from '@app/types/dropdown'
import { LntForm, LntInputSearch } from '@app/components/base'

import { SIZE } from '@app/constants'

import { getToolbar } from './utils'
import { Menu, Toolbar } from './components'

import styles from './styles.module.scss'

import type { ChangeEvent } from 'react'
import type { CustomDropdownMenuProps } from './types'

export const DropdownMenu: React.FC<CustomDropdownMenuProps> = ({
  toolbar: rawToolbar,
  className: outerClassName,
  items = [],
  defaultItems = items,
  isSortable,
  isMultiple,
  isSearchable,
  searchValue,
  onAccept,
  onSelect,
  onChange
}) => {
  const [searchInput, setSearchInput] = useState<string>('')

  const className = classNames(styles.dropdownMenu, outerClassName)

  const toolbar = useMemo(() => getToolbar(rawToolbar, isMultiple), [rawToolbar, isMultiple])

  const handleSearch = (event: ChangeEvent<HTMLInputElement>): void => {
    setSearchInput(event.target.value)
  }

  const handleDropdownMenuClick = (items: DropdownMenuItem[], item?: DropdownMenuItem): void => {
    onSelect?.(items, item)

    if (!toolbar?.accept) {
      onAccept?.(items)
    }
  }

  const handleFinish = (): void => {
    onAccept?.(items)
  }

  const handleReset = (): void => {
    if (isSearchable) {
      setSearchInput('')
    }

    if (!toolbar?.accept) {
      onAccept?.(defaultItems)
    }

    onSelect?.(defaultItems)
    onChange?.(defaultItems)
  }

  return (
    <LntForm
      className={ className }
      onSubmit={ handleFinish }
    >
      <Show condition={ isSearchable }>
        <div className={ styles.dropdownMenu__searchWrapper }>
          <LntInputSearch
            allowClear
            placeholder='Поиск'
            size={ SIZE.middle }
            value={ searchInput }
            onChange={ handleSearch }
          />
        </div>
      </Show>

      <Menu
        items={ items }
        isSortable={ isSortable }
        isMultiple={ isMultiple }
        searchValue={ isSearchable ? searchInput : searchValue }
        onSelect={ handleDropdownMenuClick }
        onChange={ onChange }
      />

      <Toolbar
        toolbar={ toolbar }
        onReset={ handleReset }
      />
    </LntForm>
  )
}
